module.exports = __webpack_public_path__ + "img/logo_shoppingcolor.b96d6115.png";